import React, { useState, useEffect } from 'react';
import HomePage from './pages/HomePage'
import Portfolio from './pages/Portfolio';
import ProjectDetail from './pages/ProjectDetail'
import About from './pages/About'
import People from './pages/People';
import PersonDetail from './pages/PersonDetail';
import Contact from './pages/Contact';
import IntroAnimation from './components/IntroAnimation';
import teamMembersData from './json/teamMembers.json'; // Adjust the path to where your JSON file resides


import {
    Routes,
    Route,
} from 'react-router-dom';

function App() {
    const [projects, setProjects] = useState([]);
    const [showAnimation, setShowAnimation] = useState(!sessionStorage.getItem("animationShown"));
    const [teamMembers, setTeamMembers] = useState(teamMembersData);


    useEffect(() => {
        // Fetch the projects data from Strapi
        fetch('https://schediopartners.com/api/projects?populate=*') // https://schediopartners.com/api/projects?populate=*  http://localhost:1337/api/projects?populate=*
            .then(response => response.json())
            .then(data => {
                const extractedAttributes = data.data.map(item => item.attributes);
                setProjects(extractedAttributes);
            })
            .catch(err => console.error('Error loading projects:', err));
    }, []);
    

    return (
        <div className="bg-[#e5dedb] min-h-screen">
            {showAnimation && <IntroAnimation onAnimationEnd={() => setShowAnimation(false)} />}
            <Routes>
                <Route path="/" element={<HomePage />} index />
                <Route path="/portfolio" element={<Portfolio projects={projects} />} />
                <Route path="/portfolio/:projectId" element={<ProjectDetail projects={projects} />} />
                <Route path="/about" element={<About />} />
                <Route path="/people" element={<People teamMembers={teamMembers} />} />
                <Route path="/people/:personId" element={<PersonDetail teamMembers={teamMembers} />} />   {/* New route */}
                <Route path="/contact" element={<Contact />} />
            </Routes>
        </div>
    );
}

export default App;
